/*
 * 通知オフ（show_cart_notification = false）用の無音ハンドラ。
 * product-form.js は cart-notification / cart-drawer が無いと /cart へリダイレクトするため、
 * ポップアップもリダイレクトも出さない no-op の <cart-notification> を登録する。
 */
if (!customElements.get('cart-notification')) {
  customElements.define(
    'cart-notification',
    class extends HTMLElement {
      getSectionsToRender() {
        return [];
      }

      setActiveElement() {}

      renderContents() {}
    }
  );
}
